import { Pipe, PipeTransform } from '@angular/core';
import { EnvironmentService } from '../../services';

@Pipe({
  name: 'apiUrl',
})
export class ApiUrlPipe implements PipeTransform {
  constructor(private readonly service: EnvironmentService) {}

  public transform(value: string): string {
    return `${this.service && this.service.environment ? this.service.environment.apiUrl : ''}${value}`;
  }
}
